import { throttle } from "lodash-es";
import Catalogue from './catalogue';
const __script_base__ = {
  name: 'ComponentListWithCatalogue',
  components: {
    Catalogue
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    // 就是 item[]
    categoryKey: {
      type: [String, Function],
      required: true
    },
    hideCatalogue: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
    defaultCategory: {
      type: [String, Function],
      default: '未分组'
    },
    // 也可为 `(item) => string`，如果为空则会不展示当前项
    filterKey: {
      type: String,
      default: ''
    },
    // 支持 .sync
    filterFunction: {
      type: Function,
      default: null
    } // 配合 filter 使用，为 `(filter, item) => boolean`
  },
  data() {
    return {
      activeGroup: '',
      actualFilterKey: ''
    };
  },
  computed: {
    allGroups() {
      const {
        data,
        categoryKey,
        defaultCategory
      } = this;
      const map = new Map();
      data.forEach(item => {
        let group = typeof categoryKey === 'function' ? categoryKey(item) : item[categoryKey];
        if (group === null || group === '') {
          group = typeof defaultCategory === 'function' ? defaultCategory(item) : defaultCategory;
        }
        if (!Array.isArray(group)) {
          group = [group];
        }
        if (!group) return;
        group.forEach(g => {
          if (!map.has(g)) {
            map.set(g, [item]);
          } else {
            map.get(g).push(item);
          }
        });
      });
      return Array.from(map.entries(), ([group, items]) => ({
        group,
        items
      }));
    },
    filteredGroups() {
      const {
        actualFilterKey,
        filterFunction
      } = this;
      if (!actualFilterKey || typeof filterFunction !== 'function') return this.allGroups;
      return this.allGroups.map(({
        items,
        ...rest
      }) => ({
        ...rest,
        items: items.filter(item => filterFunction(actualFilterKey, item))
      })).filter(x => x.items.length > 0);
    }
  },
  created() {
    this.$watch('filterKey', k => {
      var _this$$refs$groupCont;
      if (k !== this.actualFilterKey) this.actualFilterKey = k;
      (_this$$refs$groupCont = this.$refs.groupContainer) === null || _this$$refs$groupCont === void 0 || _this$$refs$groupCont.scrollTo(0, 0);
    }, {
      immediate: true
    });
  },
  mounted() {
    this.syncScroll = throttle(this.syncScroll, 30);
    this.syncScroll();
    this.$watch('filteredGroups', this.syncScroll);
  },
  beforeDestroy() {},
  methods: {
    gotoGroup(group) {
      const {
        groupContainer,
        groupElements
      } = this.$refs;
      const groupElement = groupElements.find(x => x.getAttribute('data-group') === group);
      groupContainer.scrollTo(0, groupElement.offsetTop);
      this.$nextTick(() => this.syncScroll());
    },
    syncScroll() {
      var _this$filteredGroups$, _groupElementsShallow;
      const {
        groupContainer,
        groupElements
      } = this.$refs;
      let curr = (_this$filteredGroups$ = this.filteredGroups[0]) === null || _this$filteredGroups$ === void 0 ? void 0 : _this$filteredGroups$.group;
      const testLineTop = Math.min(30, groupContainer.offsetHeight * 0.2) + groupContainer.scrollTop;
      const groupElementsShallow = [...groupElements].sort((a, b) => a.offsetTop - b.offsetTop);
      curr = groupElementsShallow.length > 0 && ((_groupElementsShallow = groupElementsShallow.reduce((a, b) => {
        if (b.offsetTop > testLineTop) return a;
        return b;
      })) === null || _groupElementsShallow === void 0 ? void 0 : _groupElementsShallow.getAttribute('data-group')) || curr;
      if (curr === this.activeGroup) return;

      // 左侧可能也需要滚动

      this.activeGroup = curr;
      this.$nextTick(() => {
        const {
          catalogueContainer,
          catalogueElements
        } = this.$refs;
        const catalogueElement = catalogueElements === null || catalogueElements === void 0 ? void 0 : catalogueElements.find(x => x.getAttribute('data-group') === curr);
        if (!catalogueElement) return;
        const iTop = catalogueElement.offsetTop;
        const iBottom = iTop + catalogueElement.offsetHeight;
        const cScrollTop = catalogueContainer.scrollTop;
        const cHeight = catalogueContainer.offsetHeight;
        if (iBottom > cScrollTop + cHeight) {
          catalogueContainer.scrollTo(0, Math.max(0, iBottom - cHeight));
        }
        if (iTop < cScrollTop) {
          catalogueContainer.scrollTo(0, Math.max(0, iTop));
        }
      });
    }
  }
};
var render = function () {
  var this$1 = this;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-listWithCatalogue default-item",
    class: {
      hideCatalogue: _vm.hideCatalogue
    }
  }, [_vm.showSearch ? _c("div", {
    ref: "searchContainer",
    staticClass: "ucd-listWithCatalogue-searchContainer"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.actualFilterKey,
      expression: "actualFilterKey"
    }],
    staticClass: "uc-inputbox ucd-listWithCatalogue-search",
    attrs: {
      type: "text",
      placeholder: _vm.searchPlaceholder
    },
    domProps: {
      value: _vm.actualFilterKey
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.actualFilterKey = $event.target.value;
      }, function (ev) {
        this$1.$emit("update:filterKey", ev.target.value);
      }]
    }
  }), _vm._v(" "), _c("i", {
    staticClass: "ucd-listWithCatalogue-searchIcon fa fa-search"
  })]) : _vm._e(), _vm._v(" "), _c("catalogue", {
    attrs: {
      groups: _vm.filteredGroups.map(function (g) {
        return g.group;
      }),
      "active-group": _vm.activeGroup
    },
    on: {
      gotoGroup: function (group) {
        return _vm.gotoGroup(group);
      }
    }
  }), _vm._v(" "), _c("div", {
    ref: "groupContainer",
    staticClass: "ucd-listWithCatalogue-groupContainer template-show",
    on: {
      scroll: _vm.syncScroll,
      mousewheel: _vm.syncScroll
    }
  }, [!_vm.filteredGroups.length && _vm.$slots.empty ? _c("div", {
    staticClass: "ucd-listWithCatalogue-slotForEmpty"
  }, [_vm._t("empty")], 2) : _vm._e(), _vm._v(" "), _vm._l(_vm.filteredGroups, function (ref) {
    var group = ref.group;
    var items = ref.items;
    return _c("div", {
      key: group,
      ref: "groupElements",
      refInFor: true,
      staticClass: "ucd-listWithCatalogue-group",
      attrs: {
        "data-group": group
      }
    }, [_c("a-collapse", {
      staticClass: "panelStyle",
      attrs: {
        "default-active-key": _vm.filteredGroups.map(function (item) {
          return item.group;
        })
      }
    }, [_c("template", {
      slot: "expandIcon"
    }, [_c("a-icon", {
      attrs: {
        type: "caret-right"
      }
    })], 1), _vm._v(" "), _c("a-collapse-panel", {
      key: group,
      attrs: {
        header: group
      }
    }, [_c("div", {
      staticClass: "ucd-listWithCatalogue-group-content"
    }, [_vm._l(items, function (item, index) {
      return _vm._t("item", function () {
        return [_c("div", {
          key: group + ":" + index,
          staticClass: "ucd-listWithCatalogue-defaultItem",
          on: {
            click: function ($event) {
              return _vm.$emit("click-item", item);
            }
          }
        }, [_c("img", {
          staticClass: "ucd-listWithCatalogue-defaultItem-icon",
          attrs: {
            src: item.icon
          }
        }), _vm._v(" "), _c("div", {
          staticClass: "ucd-listWithCatalogue-defaultItem-title"
        }, [_vm._v("\n                  " + _vm._s(item.name || item.id) + "\n                ")])])];
      }, {
        group: group,
        item: item,
        index: index
      });
    })], 2)])], 2)], 1);
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/ComponentListWithCatalogue/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);